import { GAME_TAG } from "./game";

// TODO: [CONSTANTS] Update with official information
export const endVotingDate = new Map([
  [GAME_TAG.CS, "2024-01-14T23:59:59"],
  [GAME_TAG.VALORANT, "2024-01-14T23:59:59"],
]);
